// Override authentication sidebar animation - FULL PREVENTION
document.addEventListener('DOMContentLoaded', function() {
  // Function to check for login state and apply appropriate class
  function checkLoginState() {
    const authSidebar = document.getElementById('halo-auth-sidebar');
    if (!authSidebar) return;
    
    // Check if account dropdown exists (user is logged in)
    const accountDropdown = authSidebar.querySelector('.account-dropdown');
    
    if (accountDropdown) {
      authSidebar.classList.add('has-account-dropdown');
    } else {
      authSidebar.classList.remove('has-account-dropdown');
    }
  }
  
  // Run initially
  checkLoginState();
  
  // Also run on mutations to the sidebar
  const sidebarObserver = new MutationObserver(function(mutations) {
    checkLoginState();
  });
  
  // Start observing the sidebar for changes
  const authSidebar = document.getElementById('halo-auth-sidebar');
  if (authSidebar) {
    sidebarObserver.observe(authSidebar, { childList: true, subtree: true });
  }
  // Apply CSS fixes for body sliding immediately
  const bodyFixStyles = document.createElement('style');
  bodyFixStyles.innerHTML = `
    html, body {
      --scrollbar-width: calc(100vw - 100%);
    }

    /* Force prevent ALL sliding for body and fixed positioning */
    html body.auth-sidebar-show {
      transform: none !important;
      margin-left: 0 !important;
      left: 0 !important;
      transition: none !important;
      --scrollbar-compensation: 0px !important;
    }

    /* Kill all transitions and transforms for body-related elements */
    html body.auth-sidebar-show * {
      transition-duration: 0s !important;
    }
  `;
  document.head.appendChild(bodyFixStyles);

  // Override the sidebar open function with immediate showing
  const originalSetOpenSidebar = CustomerAuth.prototype.setOpenSidebar;
  
  if (originalSetOpenSidebar) {
    CustomerAuth.prototype.setOpenSidebar = function(event) {
      event.preventDefault();
      event.stopPropagation();
      
      // Store original scroll position
      const scrollY = window.scrollY;
      
      // Add class without animation
      document.body.classList.add('auth-sidebar-show');
      
      // Ensure body doesn't move - force override any sliding that might happen
      document.body.style.position = 'static';
      document.body.style.width = '100%';
      document.body.style.marginLeft = '0';
      document.body.style.transform = 'none';
      document.body.style.transition = 'none';
      
      // Restore scroll position in case it was modified
      window.scrollTo(0, scrollY);
    };
  }
  
  // Override the sidebar close function with immediate hiding
  const originalSetCloseSidebar = CustomerAuth.prototype.setCloseSidebar;
  
  if (originalSetCloseSidebar) {
    CustomerAuth.prototype.setCloseSidebar = function(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      // Store original scroll position
      const scrollY = window.scrollY;
      
      // Remove animation class
      document.body.classList.remove('auth-sidebar-show');
      
      // Ensure body resets completely
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.marginLeft = '';
      document.body.style.transform = '';
      document.body.style.transition = '';
      
      // Restore scroll position
      window.scrollTo(0, scrollY);
    };
  }
  
  // Add a MutationObserver to watch for auth-sidebar-show class changes
  const bodyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        // Check if auth-sidebar-show was added
        if (document.body.classList.contains('auth-sidebar-show')) {
          // Force body position to be static
          document.body.style.position = 'static';
          document.body.style.width = '100%';
          document.body.style.marginLeft = '0';
          document.body.style.transform = 'none';
          document.body.style.transition = 'none';
        }
      }
    });
  });
  
  // Start observing body for class changes
  bodyObserver.observe(document.body, { attributes: true });
});
